'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onBeforePlay(event, player) {
  var currentVideo = player.getPlaylistItem();

  if (!this.state.hasPlayed && !this.state.adHasPlayed && typeof this.props.generatePrerollUrl === 'function') {
    player.playAd(this.props.generatePrerollUrl(currentVideo));
  }
}

exports.default = onBeforePlay;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-before-play.js
// module id = 1782
// module chunks = 1